/**
 * "New document" tracking for the Easer portal: the names of the documents already seen are kept per
 * Easer on the device; anything not in that list shows a red dot on the Documents tab and a « Nouveau » badge.
 */
const key = (userId) => `easer_docs_seen_${userId}`;

export const getSeenDocs = (userId) => {
  try { return new Set(JSON.parse(localStorage.getItem(key(userId)) || '[]')); } catch { return new Set(); }
};

export const markDocsSeen = (userId, items) => {
  try { localStorage.setItem(key(userId), JSON.stringify(items.map((d) => d.relativename))); } catch { /* quota */ }
  try { window.dispatchEvent(new Event('easer:docs-seen')); } catch { /* old browsers */ }
};

export const countNewDocs = (userId, items) => {
  const seen = getSeenDocs(userId);
  return items.filter((d) => !seen.has(d.relativename)).length;
};
